/**
 * Created by vlad.p on 10/2/2017.
 */

export class TariffHelper {

    public static isCustomTariff(tariff: string): boolean {
        if(tariff.toLowerCase().includes('free'))
            return false;

        let measures: string[] = [ 'kg', '¢', '%', '$', 'cent', 'percent' ];

        for(let measure of measures) {
            if(tariff.includes(measure))
                return false;
        }

        return true;
    }

}


// WEBPACK FOOTER //
// ./app/common/helpers/tariffHelper.ts